import React, { useState } from "react";
import "./Overview.css";
import { overviewContent } from "../../data/content";

import bg from "../../assets/images/Group 9.png";
import cardImg from "../../assets/images/card.png";

const Overview = () => {

  const [revealed, setRevealed] = useState(false);

  return (
    <section
      id="overview"
      className="overview"
      style={{ backgroundImage: `url(${bg})` }}
      onMouseEnter={() => setRevealed(true)}
    >
      <div className={`overview-card ${revealed ? "show" : ""}`}>
        <img className="overview-card-bg" src={cardImg} alt="" />

        <div className="overview-card-content">
          <h2 className="overview-title">{overviewContent.title}</h2>

          <p className="overview-text">
            {overviewContent.text}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Overview;